import { guardContext, useClientContext } from "../../Context";
// have to do this because type assertion functions have some stupid restrictions
var hasContext = guardContext;
var useLocale = function() {
    var context = useClientContext("locale");
    hasContext("locale", context);
    var _value = context.value, locale = _value.locale, language = _value.language, market = _value.market;
    return {
        locale: locale,
        language: language,
        market: market
    };
};
export { useLocale };
